import React, { Component, PropTypes } from 'react';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { connect } from 'react-redux';
import { onThemePropChange } from '../../../helpers/ThemeStoreHelpers';

class HeaderIcon extends Component {
    render() {
        return (
            <div className="HeaderIcon">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="row">
                            <div className="col-xs-12 col-sm-3">
                                <PresetColorPicker
                                    isDisabled={this.props.isDisabled}
                                    color={this.props.userBar.iconColor.normal}
                                    onColorChange={this.props.onThemePropChange('iconColor.normal')}
                                />
                                Normal
                            </div>
                            <div className="col-xs-12 col-sm-3">
                                <PresetColorPicker
                                    isDisabled={this.props.isDisabled}
                                    color={this.props.userBar.iconColor.hover}
                                    onColorChange={this.props.onThemePropChange('iconColor.hover')}
                                />
                                Hover
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HeaderIcon.propTypes = {
    children: PropTypes.element,
    availableFonts: PropTypes.array,
    availableFontSizes: PropTypes.array,
    availableFontWeights: PropTypes.object,
    settings: PropTypes.object,
    tagNameName: PropTypes.string
};

const mapHeaderIconStateToProps = (state, ownProps) => {
    return { ...state.app.data.theme.header, ...state.theme.header };
};

const mapHeaderIconDispatchToProps = dispatch => ({
    onThemePropChange: onThemePropChange(dispatch, 'header.userBar')
});

export default connect(mapHeaderIconStateToProps, mapHeaderIconDispatchToProps)(HeaderIcon);



// WEBPACK FOOTER //
// ./src/components/pages/theme/header/Icon.js